<template>
  <div class="form__group form__group--selection" :class="getExternalClass()">
    <div class="form__input form__input--selection" :class="isFocused()">
      <input 
        type="checkbox" 
        :id="id"
        :required="required"
        @change="onUpdate($event)"
        :checked="currentValue"
        :value="currentValue"
        @click="onClick"
        @focus="onChange"
        @blur="onBlur"
        :disabled="disabled"
      />
      <label :for="id" v-html="label"></label>
      <lennoc-icon image="check--large"></lennoc-icon>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch, onMounted } from 'vue'

  const props = defineProps({
    id: {
      type: String,
      default() {
        return ''
      }
    },
    label: {
      type: String,
      required: true,
      default() {
        return ''
      }
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    domclass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  })

  const emits = defineEmits(['update:modelValue', 'clicked'])

  const currentValue = ref<boolean>(props.modelValue)
  const hasFocus = ref<boolean>(false)

  watch(() => props.modelValue, (newVal) => {
    currentValue.value = newVal
  })

  const updateValue = (newValue: boolean) => {
    currentValue.value = newValue
    emits('update:modelValue', currentValue.value) 
  }

  const onUpdate = (event: Event) => {
    const checkboxEl = event.currentTarget as HTMLInputElement
    updateValue(checkboxEl.checked)
  }

  const onChange = () => {
    hasFocus.value = true
  }

  const onClick = () => {
    const newValue = !currentValue.value
    updateValue(newValue) 
    emits('clicked', newValue)
  }

  const onBlur = () => {
    hasFocus.value = false
  }

  const getExternalClass = () => {
    return props.domclass
  }

  const isFocused = () => {
    return hasFocus.value ? 'form__input--focus' : ''
  }
</script>

